import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eb4f51d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h5 font-weight-bold" }, "En ce Moment", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h5 font-weight-bold" }, "À Venir", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h5 font-weight-bold" }, "Précédement", -1))

import { inject, ref } from "vue";
import { useRoute } from "vue-router";

import EventCard from "../components/EventCard.vue";
import EventsWithFilter from "@/components/EventsWithFilter.vue";
import type { Event } from "@emblem/api";


const __default__ = {
  name: "NewsPage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const events = inject("events:record") as Record<string, Event>;

const currentEventDialog = ref(false);
const currentEvent = ref<Event | null>(null);

const route = useRoute();
if (typeof route.query.show === "string") {
  const event = events[route.query.show];
  if (event) {
    currentEvent.value = event;
    currentEventDialog.value = true;
  }
}

const isCurrent = (event: Event) => {
  const now = new Date();
  return event.start <= now && event.end >= now;
};
const isFuture = (event: Event) => event.start > new Date();
const isPast = (event: Event) => event.end < new Date();

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EventsWithFilter, null, {
      default: _withCtx(({ events }) => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            (events.filter(isCurrent).length)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12",
                  class: "px-0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_component_v_divider, { class: "mb-2" }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.filter(isCurrent), (event) => {
                      return (_openBlock(), _createBlock(EventCard, {
                        key: event._id,
                        event: event,
                        class: "mb-2"
                      }, null, 8, ["event"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (events.filter(isFuture).length)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "12",
                  class: "px-0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_v_divider, { class: "mb-2" }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.filter(isFuture), (event) => {
                      return (_openBlock(), _createBlock(EventCard, {
                        key: event._id,
                        event: event,
                        class: "mb-2"
                      }, null, 8, ["event"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (events.filter(isPast).length)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  cols: "12",
                  class: "px-0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createVNode(_component_v_divider, { class: "mb-2" }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.filter(isPast), (event) => {
                      return (_openBlock(), _createBlock(EventCard, {
                        key: event._id,
                        event: event,
                        class: "mb-2"
                      }, null, 8, ["event"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    (currentEvent.value)
      ? (_openBlock(), _createBlock(_component_v_overlay, {
          key: 0,
          modelValue: currentEventDialog.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentEventDialog).value = $event)),
          class: "current-event align-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(EventCard, { event: currentEvent.value }, null, 8, ["event"]),
            _createVNode(_component_v_btn, {
              position: "absolute",
              size: "x-small",
              icon: "fas fa-times",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (currentEventDialog.value = false))
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})